import React, { useEffect, useState } from 'react';

// import { useMediaQuery } from 'usehooks-ts';

import StreamCard from '@/components/common/components/StreamCard';

const StreamComponent = ({ streamData, linkUrl }: any) => {
  const [showAll, setShowAll] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  // const isLargeScreen = useMediaQuery('(min-width: 1024px)');
  const isLargeScreen = typeof window !== 'undefined' && window.innerWidth >= 1024;
  const [isLandscape, setIsLandscape] = useState(false);
  const displayItems = isLandscape ? 9 : 8;

  // Filter streams once when data is available to avoid recalculations
  const filteredStreams = streamData?.results?.filter((stream: any) => stream?.college_names?.count !== 0) ?? [];

  // Pre-calculate what will be shown to avoid layout shifts
  const displayedStreams = !isLargeScreen && !showAll ? filteredStreams?.slice(0, displayItems) : filteredStreams;

  useEffect(() => {
    // Set mounted state to prevent hydration mismatch
    setIsMounted(true);

    const handleOrientationChange = () => {
      const isLandscapeOrientation = window?.innerWidth > window?.innerHeight;
      setIsLandscape(isLandscapeOrientation);
    };

    handleOrientationChange();
    window.addEventListener('resize', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleOrientationChange);
    };
  }, []);

  // Skip rendering until client-side hydration completes
  if (!isMounted) {
    return (
      <div className="relative min-h-[320px] lg:min-h-[225px]">
        {/* Reserve space with minimum height to prevent layout shift */}
      </div>
    );
  }

  return (
    <div className="relative">
      {isLargeScreen ? (
        <div className="grid grid-cols-5 gap-1">
          {filteredStreams.map((streams: any) => (
            <div key={streams.id} className="min-h-[70px]">
              <StreamCard streams={streams} numberOfColleges={streams?.college_names?.count ?? 0} linkUrl={linkUrl} />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 xs:grid-cols-3">
          {displayedStreams.map((streams: any) => (
            <div key={streams.id} className="min-h-[70px]">
              <StreamCard streams={streams} numberOfColleges={streams.college_names?.count ?? 0} linkUrl={linkUrl} />
            </div>
          ))}
        </div>
      )}

      {/* Show More button for small screens */}
      {!isLargeScreen && filteredStreams.length > displayItems && (
        <div className="mt-3 flex min-h-[40px] w-full items-center justify-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="rounded-full border border-primary bg-gray-200 px-4 py-1 text-xs text-primary"
          >
            {showAll ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )}
    </div>
  );
};

export default StreamComponent;
